import RefreshIcon from '@mui/icons-material/Refresh';
import { FormControl, IconButton, MenuItem, OutlinedInput, Select, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import React, {useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ROLES } from '../../../config';
import { StatutCollabBackOffice } from '../../../data/Interfaces';
import usePostRequest from '../../../hooks/usePostRequest';
import { ColorBackgroundComponent } from '../../Client/CollaboratorsClient/ChangeStatutCollaborateur';

const StatutBackOffice = ({ defaultStatusCollab, rowSelected, width, mode }) => {

    StatutBackOffice.propTypes = {
        rowSelected: PropTypes.any,
        width: PropTypes.any,
        defaultStatusCollab: PropTypes.any,
        mode: PropTypes.any,
        getMyCollaborators: PropTypes.func,
    };
    const [statusCollaborateur, setStatusCollaborateur] = useState(rowSelected);
    const {postData} = usePostRequest();
    const { i18n } = useTranslation();
    useEffect(() => {
        if (rowSelected) {
            setStatusCollaborateur(rowSelected);
        }
    }, [rowSelected]);

    const disabledSelect = () => {
        //on peut pas modifier le statut d'un collab si on a pas le mode edit
        // mm dans le mode edit on pourra pas modifier le statut actif et le statut en attente
        //console.log('defaultStatusCollab', defaultStatusCollab);
        if ((mode == 'edit' && (defaultStatusCollab == 'actif' || defaultStatusCollab == 'enAttente')) || mode != 'edit' ){
            return true;
        }
        else
            return false;
    };

    const renovoyerInv = async () => {
        try {
            const response = await postData({url:'admin/inviteBackOfficeByHTHAdmin', payload:{
                role: ROLES.Admin, email:rowSelected?.email_, nom:rowSelected?.nom, prenom:rowSelected?.prenom, tele:rowSelected?.tele,
            }});
            console.log(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div style={{display:'flex',flexDirection:'row',gap:'8px'}}>
            <FormControl
                //sx={{ m: 1, width: 200, }}
                variant="outlined"
                style={{ width: width }}
                size='small'
            >
                <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    input={<OutlinedInput />}
                    //defaultValue={defaultStatusCollab}
                    value={statusCollaborateur?.statut}
                    disabled={disabledSelect() == true ? true : false}
                    onChange={(e) => {
                        let a=statusCollaborateur;
                        a.statut=e.target.value;
                        setStatusCollaborateur(a);
                    }}
                    style={{ backgroundColor: ColorBackgroundComponent(statusCollaborateur?.statut), width: width }}
                >
                    {StatutCollabBackOffice.map((option, i) => {
                        return (
                            //j'ai masqué le statut enAttente prcq l'admin pourra pas changer le statut d'un collab vers en attente
                            <MenuItem
                                style={{ width: width }}
                                key={i}
                                hidden={option?.value == 'enAttente' ? true : false}
                                value={option.value}
                            >
                                {i18n.t(option?.label)}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
            {defaultStatusCollab == 'enAttente' &&
                <Tooltip title={i18n.t('Renvoyer une invitation')}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={renovoyerInv}
                        aria-label="close"
                    >
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            }
        </div>
    );
};

export default StatutBackOffice;